<template>
    <section class="swiper-slide probootstrap-hero probootstrap-image" :class="['bgColor'+navIndex]">
        <img id="probootstrapBgImg" :class="'probootstrapBgImg'+navIndex" ref="probootstrapBgImg" :src="require('../assets/common/header'+navIndex+'.png')"/>
        <a href="javascript:">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="probootstrap-slider-text" data-animate-effect="fadeIn">
                            <h1 :class="['probootstrap-heading','navIndex'+navIndex]" v-if="navIndex===1">
                                <p>智能穿戴心血管数字化专家</p>
                                <div>华为智能手表健康管理系统</div>
                                <div>
                                    <span class="btn" @click="handleShowConnection">商务合作
                                    <img class="iconr" src="../assets/home/iconr.png"/></span>
                                </div>
                            </h1>
                            <h1 class="probootstrap-heading " v-else-if="navIndex===2">
                                <p>产品与合作</p>
                                <div>连接 <span>华为</span>智能手表和<span>301医院</span>mAFA心脏健康研究</div>
                            </h1>
                            <h1 class="probootstrap-heading " v-else-if="navIndex===3">
                                <p>智能设备健康全面守护</p>
                                <div>连接心泰健康平台，系统数字化对用户健康监测管理服务</div>
                            </h1>
                            <h1 class="probootstrap-heading " v-else-if="navIndex===4">
                                <p>人工智能穿戴算法</p>
                                <div>多参数融合分析，临床患者招募精准对比医疗器械</div>
                            </h1>
                            <h1 class="probootstrap-heading " v-else-if="navIndex===5">
                                <p>关于我们</p>
                            </h1>
                            <h1 class="probootstrap-heading " v-else-if="navIndex===6">
                                <p>智能穿戴心血管数字化专家</p>
                                <div>— 华为智能手表健康管理系统</div>
                            </h1>
                            <h1 class="probootstrap-heading " v-else-if="navIndex===7">
                                <p>心泰健康</p>
                                <div>— 华为智能手表健康管理系统</div>
                                <div class="mp">健康检测、预警等综合管理解决方案</div>
                            </h1>
                            <h1 class="probootstrap-heading " v-else-if="navIndex===9">
                                <p>智能穿戴健康研究</p>
                                <div>智能穿戴心血管健康监测、预警和干预技术研究</div>
                                <!-- <div class="mp">将可穿戴设备，人工智能，<br/> -->
                                    <!-- 移动医疗等智能技术应用于房颤<br/>及其相关心血管风险和疾病的筛查、<br/>诊断、人工智能预警及整合管理的研究</div> -->
                                <!-- <div class="mp">健康检测、预警等综合管理解决方案</div> -->
                            </h1>
                            <h1 class="probootstrap-heading " v-else-if="navIndex===10">
                                <p>心泰商城</p>
                                <div class="mp">华为智能手表、心泰智能手表、呼吸机、制氧机</div>
                            </h1>
                            <h1 class="probootstrap-heading " v-else-if="navIndex===11">
                                <p>健康医疗系统</p>
                                <div class="mp">数字化、可视化后台管理系统</div>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    </section>
</template>

<script>
    export default {
        name: "headerTop",
        data() {
            return {
                navIndex: 1,
                title:'',
                text:''
            }
        },
        mounted() {
            let pathname = window.location.pathname;
            if (pathname.indexOf('home') !== -1) {
                this.navIndex = 1;
            } else if (pathname.indexOf('cooperation') !== -1) {
                this.navIndex = 2;
            } else if (pathname.indexOf('wear') !== -1) {
                this.navIndex = 3;
            } else if (pathname.indexOf('algorithm') !== -1) {
                this.navIndex = 4;
            } else if (pathname.indexOf('about') !== -1) {
                this.navIndex = 5;
            } else if (pathname.indexOf('endowment') !== -1) {
                this.navIndex = 6;
            } else if (pathname.indexOf('medical') !== -1) {
                this.navIndex = 7;
            }else if (pathname.indexOf('oxygen') !== -1) {
                this.navIndex = 8;
            } else if (pathname.indexOf('extension') !== -1) {
                this.navIndex = 9;
            } else if (pathname.indexOf('mall') !== -1) {
                this.navIndex = 10;
            } else if (pathname.indexOf('system') !== -1) {
                this.navIndex = 11;
            }  else if (pathname.indexOf('xintai') !== -1) {
                this.navIndex = 13;
            }else {
                this.navIndex = 2;
            }
        },
        methods:{
            handleShowConnection(){
                this.$emit('return',true)
            }
        }
    }
</script>

<style scoped>
    .probootstrap-image{
        background: linear-gradient(180deg, #2064e0,#5292fe);
    }
    #probootstrapBgImg{
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        object-fit: contain;
        height: 100%;
        z-index: 0;
        background-size: 100%;
    }
    .probootstrapBgImg1{
        top: 40%;
    }
    .navIndex1{
        margin-top: -40px;
    }                  
    .navIndex1 p,.navIndex1 div{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100% !important;
        max-width: 100% !important;
    }
    .navIndex1 p{
        margin: 0 !important;
    }
    .bgColor1{
        height: 800px !important;
    }
    .bgColor1 #probootstrapBgImg{
        height: 75%;
    }
    .bgColor2{
        background:linear-gradient(180deg,#1e62df,#1f63e0,#3375ec,#4887f8)
    }
    .bgColor3{
        /* background: linear-gradient(180deg,#1e62df,#1f63e0,#3375ec,#4887f8) */
        background:linear-gradient(to right,#595DFF,#595DFF,#72BBFF,#72BBFF)
    }
    .bgColor4{
        /* background: linear-gradient(180deg, #397afd,#4680f3,#638ddd) */
        background:linear-gradient(to right,#595DFF,#595DFF,#72BBFF,#72BBFF)
    }
    .bgColor5{
        background: linear-gradient(180deg, #3377fd,#638ddd)
    }
    .bgColor9{
        /* background: linear-gradient(180deg, #205ac7,#4d8afb) */
        background:linear-gradient(to right,#595DFF,#595DFF,#72BBFF,#72BBFF)
    }
    .bgColor10{
        background:linear-gradient(180deg,#6ca0ff,#4883ee,#2c6be1,#2c6be1,#427ce8,#99bdff)
    }
    .bgColor11{
        /* background: linear-gradient(180deg, #2d69eb,#78c8fe) */
        background:linear-gradient(to right,#595DFF,#595DFF,#72BBFF,#72BBFF)
    }
    .bgColor10 img{
        object-fit:cover !important;
    }
    .probootstrap-image1 {
        background: url("../assets/common/header1.png");
        height: 720px!important;
    }


    .mp{
        font-size: 20px!important;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 28px!important;
    }
    .probootstrap-heading {
        font-size: 30px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 42px;
    }

    .probootstrap-heading p {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 33px;
    }

    .probootstrap-heading div {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 30px;
        margin-top: 12px;
        display: flex;
        align-items: center;
    }

    .probootstrap-heading .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 180px;
        height: 60px;
        border: 1px solid #FFFFFF;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #005EF0;
        line-height: 28px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(4,5,104,0.3);
        border-radius: 10px;
    }

    .probootstrap-heading span {
        display: inline-flex;
        margin: 0!important;
    }


    @media screen and (min-width: 1200px) {
        .indexH .probootstrap-slider-text {
            /* padding-top: 280px; */
            padding-top: 180px;
            padding-bottom: 100px;
        }

        .probootstrap-hero .probootstrap-slider-text h1 .wrap {
            max-width: 50%;
        }
    }

    @media screen and (max-width: 1000px) {
        .indexH .probootstrap-slider-text {
            /* padding-top: 280px; */
            padding-top: 100px;
            padding-bottom: 50px;
        }

        .probootstrap-hero .probootstrap-slider-text h1 p {
            max-width: 100%;
        }

        .probootstrap-hero .probootstrap-slider-text h1 .wrap {
            max-width: 80%;
        }
    }

    .probootstrap-image {
        width: 100%;
        /*height: auto !important;*/
        height: auto ;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        z-index: 1;
    }

    /* @media screen and (max-width: 1200px) {
      .indexH .probootstrap-slider-text{
        padding-top: 280px;
        padding-bottom: 180px;
      }
    } */
    /* .probootstrap-hero{
      height: 410px;
    } */
    #swiper33 {
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    #swiper33 .probootstrap-image {
        width: 100% !important;
    }

    #swiper33 .swiper-pagination {
        position: absolute;
        bottom: 50px;
        z-index: 99;
    }

    #swiper33 .swiper-pagination-bullet {
        width: 6px;
        height: 6px;
        margin: 0 5px;
        background: #fff;
        opacity: 0.2;
    }

    #swiper33 .swiper-pagination-bullet-active {
        background: #fff;
        opacity: 1;
    }

</style>
